export const selectIsLoading = state => state.signalR?.isLoading;

export const selectSignalRConnection = state => state.signalR?.connection;

export const selectSubscriptionDetails = state =>
  state.signalR?.subscriptionDetails;
